<template>
  <div class="tinymce-box">
    <editor v-model="myValue" :init="init" :disabled="disabled" @onClick="onClick">
    </editor>
  </div>
</template>

<script>
  import tinymce from 'tinymce/tinymce' //tinymce默认hidden，不引入不显示
  import Editor from '@tinymce/tinymce-vue'
  import 'tinymce/themes/silver'
  // 编辑器插件plugins
  // 更多插件参考：https://www.tiny.cloud/docs/plugins/
  import 'tinymce/plugins/image' // 插入上传图片插件
  import 'tinymce/plugins/media' // 插入视频插件
  import 'tinymce/plugins/table' // 插入表格插件
  import 'tinymce/plugins/lists' // 列表插件
  import 'tinymce/plugins/code' // 列表插件
  import 'tinymce/plugins/wordcount' // 字数统计插件

  export default {
    components: {
      Editor
    },
    name: 'tinymce',
    props: {
      value: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      plugins: {
        type: [String, Array],
        default: 'lists image media table wordcount indent2em lineheight code'
      },
      toolbar: {
        type: [String, Array],
        default: function() {
          return [
            ' undo redo |  formatselect fontselect fontsizeselect | alignleft aligncenter alignright alignjustify ',
            ' bold italic underline strikethrough forecolor backcolor | bullist numlist outdent indent | lists image table | removeformat code'
          ]
        }
      }
    },
    data() {
      return {
        init: {
          language_url: '/tinymce/langs/zh_CN.js',
          language: 'zh_CN',
          skin_url: '/tinymce/skins/ui/oxide',
          // skin_url: 'tinymce/skins/ui/oxide-dark',//暗色系
          min_height: 500,
          plugins: this.plugins,
          toolbar: this.toolbar,
          branding: false,
          menubar: false,
          paste_data_images: true,
          // 此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
          // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
          images_upload_handler: (blobInfo, success, failure) => {
            // const formData = new FormData();
            // formData.append('https://hr.syjhdy.com/admin/index.php/admin/qiniu/uploads', blobInfo.blob());
            // uploadFile(formData).then(res => {
            //   if (res.data.code == 0) {
            //     let file = res.data.data;
            //     success(file.filePath);
            //     return
            //   }
            //   failure('上传失败')
            // }).catch(() => {
            //   failure('上传出错')
            // })
            var xhr, formData;
            xhr = new XMLHttpRequest();
            xhr.withCredentials = false;
            xhr.open('POST', this.$host+'/admin/index.php/admin/qiniu/uploads'); //第一个参数是请求方式，第二个参数是请求地址，我这里配置的是struts的action，如果是其他（PHP等）的可这样配置：xxx.php

            xhr.onload = function() {
              var json;
              if (xhr.status !== 200) {
                failure('HTTP Error: ' + xhr.status);
                return;
              }
              if (JSON.parse(xhr.responseText) == 'https://hr.syjhdy.com/') {
                failure('上传失败');
                return;
              }
              console.log(xhr.responseText)
              success(JSON.parse(xhr.responseText).url);
            };

            formData = new FormData();
            formData.append('img', blobInfo.blob(), blobInfo.filename());
            xhr.send(formData);
          }
        },
        myValue: this.value
      }
    },
    mounted() {
      tinymce.init({})
    },
    methods: {
      // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
      // 需要什么事件可以自己增加
      onClick(e) {
        this.$emit('onClick', e, tinymce)
      },
      // 可以添加一些自己的自定义事件，如清空内容
      clear() {
        this.myValue = ''
      }
    },
    watch: {
      value(newValue) {
        this.myValue = newValue
      },
      myValue(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
</script>
<style scoped>

</style>
